import type React from "react";
import { HiCheck } from "react-icons/hi";

export interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  label?: string;
  size?: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
} as const;

export function Checkbox({
  checked,
  onChange,
  disabled = false,
  className = "",
  size = "md",
}: CheckboxProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (disabled) return;
        const key = e.key;
        if (key === " " || key === "Spacebar" || key === "Enter") {
          e.preventDefault();
          onChange(!checked);
        }
      }}
      tabIndex={disabled ? -1 : 0}
      className={`${sizeClasses[size]} rounded border-2 flex items-center justify-center cursor-pointer
          ${checked ? "bg-primary-600 border-primary-600" : "bg-white border-gray-300 hover:border-gray-400"}
          ${disabled ? "opacity-50 cursor-not-allowed" : ""}
          focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
          transition-colors duration-150 ${className}`}
      role="checkbox"
      aria-checked={checked}
      aria-disabled={disabled}
    >
      {checked && <HiCheck className="w-full h-full text-white" />}
    </div>
  );
}
